import { defineComponent as l, openBlock as r, createBlock as n, unref as a, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconHeartFilled",
  __name: "IconHeartFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (d, e) => (r(), n(a(m), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M7.5 3.37a5.25 5.25 0 0 0-5.25 5.25c0 1.694.888 3.038 1.896 4.033l6.932 7.57a1.25 1.25 0 0 0 1.844 0l6.932-7.57c1.008-.995 1.896-2.34 1.896-4.033 0-2.9-2.35-5.25-5.25-5.25-1.503 0-2.672.757-3.474 1.423a16 16 0 0 0-.8.724l-.173.164L12 5.731l-.053-.05-.173-.164a16 16 0 0 0-.8-.724C10.172 4.127 9.004 3.37 7.5 3.37m4.26 2.558.017-.01-.017.01m.463-.01.017.01-.017-.01",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
